import { useState } from "react"
import { observer } from "mobx-react"
import { Button, Col, Flex, Form, Input, Row } from "antd"
import { useForm } from "antd/es/form/Form"

import { notify } from "@src/app/components/notify"
import { securityApi } from "@src/shared/api"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"
import { useCatchFormErrors } from "@src/shared/form/base_error"

type ChangePassword = {
  confirm_password: string
  current_password: string
  new_password: string
}
export const ChangePassword = observer(() => {
  const [form] = useForm<ChangePassword>()
  const [isPending, setIsPending] = useState<boolean>(false)
  const { submit } = useCatchFormErrors(form, (values) => {
    setIsPending(true)
    return securityApi
      .changePassword(values)
      .then(() => notify.success("Your password was successfully changed"))
      .finally(() => {
        setIsPending(false)
      })
  })

  return (
    <Form
      form={form}
      id="GENERATED_ID_SETTINGSPASSWORD_FORM_VOID_1"
      layout="vertical"
      onFinish={submit}
      size="large"
    >
      <Row align="top" gutter={16}>
        <Col span={6}>
          <Form.Item
            id="GENERATED_ID_SETTINGSPASSWORD_FORM_ITEM_VOID_1"
            label="Current Password"
            name="current_password"
            required
          >
            <Input placeholder={"Enter password"} type="password" />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            id="GENERATED_ID_SETTINGSPASSWORD_FORM_ITEM_VOID_2"
            label="New Password"
            name="new_password"
            rules={[{ required: true }]}
          >
            <Input placeholder={"Enter password"} type="password" />
          </Form.Item>
        </Col>

        <Col span={7}>
          <Form.Item
            id="GENERATED_ID_SETTINGSPASSWORD_FORM_ITEM_VOID_3"
            label="Confirm Password"
            name="confirm_password"
            rules={[{ required: true }]}
          >
            <Input placeholder={"Enter password"} type="password" />
          </Form.Item>
        </Col>

        <Col span={5}>
          <Form.Item
            id="GENERATED_ID_SETTINGSPASSWORD_FORM_ITEM_VOID_4"
            label={" "}
          >
            <SubmitButton
              buttonProps={{
                disabled: isPending,
                loading: isPending,
                type: "primary",
              }}
              form={form}
            >
              Save new password
            </SubmitButton>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
})
